import React, { useCallback, useState } from "react";
import { useFormikContext } from "formik";
import { Trans, useTranslation } from "react-i18next";
import { Alert } from "components/bootstrap";
import { Row, Col } from "common/components/layout-styles";
import { useListGitRepos } from "security-app/hooks/useSigmaAPI";
import SecurityRoutes from "security-app/routing/Routes";
import { Link } from "components/common";
import { Window } from "./styledComponents";
import LeftPanel from "./LeftPanel";
import RightPanel from "./RightPanel";
import ImportErrorsAlert from "./ImportErrorsAlert";
import RuleFormWithTitle from "../RuleFormTitle";
import { DEFAULT_RULE_OPTIONS } from "../utils";
function GitRulesStep({ pathAction }) {
  const { t } = useTranslation("enterprise_security_sigma");
  const { setValues, setFieldTouched } = useFormikContext();
  const [importErrors, setImportErrors] = useState([]);
  const [repo, setRepo] = useState();
  const { repos, loadingRepos } = useListGitRepos({ page: 1, perPage: 1e4 });
  const [selectedRule, setSelectedRule] = useState();
  const onSelectionChange = useCallback(
    (ruleIds) => {
      setValues((prev) => {
        var _a, _b;
        if (ruleIds.length === 0 && ((_a = prev.rule_ids) != null ? _a : []).length === 0) return prev;
        const current = (_b = prev.rule_overrides) != null ? _b : {};
        const next = {};
        ruleIds.forEach((id) => {
          var _a2;
          next[id] = (_a2 = current[id]) != null ? _a2 : DEFAULT_RULE_OPTIONS;
        });
        return { ...prev, rule_ids: ruleIds, rule_overrides: next };
      });
      setFieldTouched("rule_ids", true, false);
    },
    [setValues, setFieldTouched]
  );
  const noRepos = !loadingRepos && repos.length === 0;
  return noRepos ? /* @__PURE__ */ React.createElement(Alert, { bsStyle: "warning" }, /* @__PURE__ */ React.createElement(
    Trans,
    {
      t,
      i18nKey: "git_rules_step.no_repos",
      components: { sigmaReposLink: /* @__PURE__ */ React.createElement(Link, { to: SecurityRoutes.SIGMA.CONFIGURATION }) }
    }
  )) : /* @__PURE__ */ React.createElement(Row, { $width: "100%", $align: "stretch", $maxWidth: "2000px", $gap: "lg", style: { margin: "0 auto" } }, /* @__PURE__ */ React.createElement(Col, { $width: "60%" }, /* @__PURE__ */ React.createElement("h2", null, t("git_rules_step.viewing"), " ", /* @__PURE__ */ React.createElement("small", null, (repo == null ? void 0 : repo.name) || "")), /* @__PURE__ */ React.createElement(Row, { $width: "100%", $align: "stretch" }, /* @__PURE__ */ React.createElement(Window, { "data-testid": "navigator", $width: 45 }, /* @__PURE__ */ React.createElement(LeftPanel, { repo, setRepo, repos, loadingRepos })), /* @__PURE__ */ React.createElement(Window, { "data-testid": "selection", $width: 65 }, /* @__PURE__ */ React.createElement(RightPanel, { onSelectionChange, setSelectedRule })))), /* @__PURE__ */ React.createElement(Col, { $width: "40%", style: { marginTop: 40 } }, /* @__PURE__ */ React.createElement(RuleFormWithTitle, { ruleId: selectedRule == null ? void 0 : selectedRule.id, ruleTitle: selectedRule == null ? void 0 : selectedRule.title, pathAction }), importErrors.length > 0 && /* @__PURE__ */ React.createElement(ImportErrorsAlert, { importErrors, setImportErrors })));
}
export default GitRulesStep;
